// extracted by mini-css-extract-plugin
export default {"projects":"style_projects__QEfuO"};